// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import {AVAILABLE_FEATURES, FEATURES} from './constants.js';

export const F = FEATURES;
export const supports = name=>AVAILABLE_FEATURES[name]===false ? false : true;

